import { api } from "@/http/api-client"
import type { TCategoryForm, TCreateCategoryResponse } from "./types"

export function createCategory(params: TCategoryForm) {
  return api.post<TCreateCategoryResponse>("/finances/categories", {
    json: params,
  })
}
